import { userConfirmCommand } from './confirm';
import { userAskForDataCommand } from './askForData';
import { userPickOptionCommand } from './pickOption';

export const userInteractionCommands = [
  userConfirmCommand,
  userAskForDataCommand,
  userPickOptionCommand,
];

export { userConfirmCommand, userAskForDataCommand, userPickOptionCommand };
